import {GlobalConstants} from "../data/GlobalConstants";
import {handleResponse} from "../util/functions";
import {getToken} from "../helpers/helperJWT";
import {loaderService} from "./loaderService";

const url = GlobalConstants.urlApi;

export const topesService = {
    getAllTopes,
    getTopeById,
    setStateTopeById,
    crudTopes,
    getRecursos
};

async function getAllTopes() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    let res = await fetch(`${url}/topes/getAllTopes`, requestOptions)
    return res.json()
}

function getTopeById(codigo) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/topes/getTopeById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function crudTopes(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/topes/crudTopes`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setStateTopeById(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/topes/setStateTopeById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

async function getRecursos() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    // let res = {}
    let productos = await fetch(`${url}/topes/getProductos`, requestOptions)
    let tipologias = await fetch(`${url}/topes/getTipologias`, requestOptions)

    // let resPro = await productos.json()
    // let resTipo = await productos.json()
    return {
        productos: await productos.json(),
        tipologias: await tipologias.json()
    }

}




